module.exports = __webpack_public_path__ + "img/flow2.a0d5265c.png";